import { ENTITY_LABELS } from "../../../utils/labelMapping";
import React, { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import classes from "./Brand.module.css";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import Table, {
  StyledTableCell,
  StyledTableRow,
} from "../../../Component/UI/Table/Table";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import Spinner from "../../../Component/Spinner/Spinner";
import EmptyView from "../../../Component/EmptyView/EmptyView";
import { deleteAttribute } from "../../../redux/actions/userSentimentActions";
import { toast } from "react-toastify";
import ConfirmTempplateModal from "../../../Component/ConfirmTemplateModal";
import { getTitleName } from "../userMetricSettingCreation";
import { QuestionMark } from "@mui/icons-material";
import { sentimentPlaceHolderReplace } from "../../../utils/helpers";

let SequenceCell = ({ item, Key, index }) => {
  return (
    <StyledTableCell component="th" scope="row" style={{ width: "10%" }}>
      <div className={classes.brand_product}>
        <span>{index + 1}</span>
      </div>
    </StyledTableCell>
  );
};

let QuestionCell = ({ item, Key, isDefault }) => {
  let [isInput, setIsInput] = useState(false);

  const blur = () => {
    setIsInput(false);
  };
  return (
    <StyledTableCell component="th" scope="row" style={{ width: "70% " }}>
      <div
        className={classes.brand_product}
        // onClick={() => {
        //   setIsInput(true);
        // }}
        // onBlur={blur}
      >
        {isInput && !isDefault ? (
          <input
            type="text"
            value={item[Key]}
            style={{ width: "100%", height: "100%" }}
          />
        ) : (
          <span>{item[Key]}</span>
        )}
      </div>
    </StyledTableCell>
  );
};

/*Sentiment question with  {{ product }} replace to {{ brand/product }} in only ui perpective but at the end when saving to database it alway  {{product}}*/
let QuestionCellWithProductReplace = ({ item, Key, isDefault }) => {
  item[Key] = sentimentPlaceHolderReplace(item?.[Key] ?? "");

  return (
    <StyledTableCell component="th" scope="row" style={{ width: "70% " }}>
      <div className={classes.brand_product}>
        <span>{item[Key]}</span>
      </div>
    </StyledTableCell>
  );
};

let QuestionCellWithWidth = ({ width }) => {
  return function QuestionCell({ item, Key, isDefault }) {
    let [isInput, setIsInput] = useState(false);

    const blur = () => {
      setIsInput(false);
    };
    return (
      <StyledTableCell component="th" scope="row" style={{ width: width }}>
        <div className={classes.brand_product}>
          {isInput && !isDefault ? (
            <input
              type="text"
              value={item[Key]}
              style={{ width: "100%", height: "100%" }}
            />
          ) : (
            <span>{item[Key]}</span>
          )}
        </div>
      </StyledTableCell>
    );
  };
};

let FactorCell = ({ item }) => {

  if (item._factorRowSpan === 0) return null;

  return (
    <StyledTableCell
      component="th"
      scope="row"
      style={{ width: "15%" }}
      rowSpan={item._factorRowSpan ?? 1}
    >
      <div className={classes.brand_product}>
        <span>{item.factor || "-"}</span>
      </div>
    </StyledTableCell>
  );
};

function groupByFactor(list) {
  const indexed = list.map((item, i) => ({ item, i }));
  indexed.sort((a, b) => {
    const fa = a.item.factor || "";
    const fb = b.item.factor || "";
    if (fa === fb) return a.i - b.i;
    if (!fa) return 1;
    if (!fb) return -1;
    return fa.localeCompare(fb);
  });
  const sorted = indexed.map(({ item }) => item);

  return sorted.map((item, idx) => {
    const factor = item.factor;
    const isFirstOfGroup = idx === 0 || !factor || sorted[idx - 1].factor !== factor;

    if (!isFirstOfGroup) {
      return { ...item, _factorRowSpan: 0 };
    }

    let span = 1;
    if (factor) {
      while (sorted[idx + span] && sorted[idx + span].factor === factor) span++;
    }
    return { ...item, _factorRowSpan: span };
  });
}

let ActionCell = ({ item, Key, isDefault, handleShowModal, editIconClick }) => {
  return (
    <StyledTableCell component="th" scope="row" style={{ width: "20%" }}>
      {!isDefault && (
        <div style={{ display: "flex", gap: "10px" }}>
          <MUIIconButton
            tooltip="Edit"
            style={{ color: "#028101" }}
            onClick={() => editIconClick(item)}
            className={classes.action_btn}
          >
            <EditOutlinedIcon />
          </MUIIconButton>
          <MUIIconButton
            tooltip="Delete"
            style={{ color: "#da1a04" }}
            onClick={() => handleShowModal(item?.id)}
            className={classes.action_btn}
          >
            <DeleteOutlineIcon />
          </MUIIconButton>
        </div>
      )}
    </StyledTableCell>
  );
};

const CHIP_COLORS = [
  "#CEB4FF80",
  "#F7C4FF80",
  "#FFBFAB80",
  "#C4FFFA80",
  "#CFCFCF80",
  "#FFDE9E80",
  "#C4FF8980",
  "#FFF27980",
];

const TABLE_HEADERS = [
  { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
  { id: "attribute", name: "Attribute", sorting: false, Cell: QuestionCell },
  { id: "action", name: "Action", sorting: false, Cell: ActionCell },
];

function renderTableHeader({ selectedTab }) {
  if (selectedTab === "core-attribute") {
    return [
      { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
      {
        id: "attribute",
        name: ENTITY_LABELS.brandPillar,
        sorting: false,
        Cell: QuestionCellWithWidth({ width: "15%" }),
      },
      {
        id: "definition",
        name: "Definition",
        sorting: false,
        Cell: QuestionCellWithWidth({ width: "55%" }),
      },

      { id: "action", name: "Action", sorting: false, Cell: ActionCell },
    ];
  } else if (selectedTab === "visibility") {
    return [
      { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
      { id: "factor", name: "Factor", sorting: false, Cell: FactorCell },
      {
        id: "attribute",
        name: `${ENTITY_LABELS.rank} Prompt`,
        sorting: false,
        Cell: QuestionCell,
      },

      { id: "action", name: "Action", sorting: false, Cell: ActionCell },
    ];
  } else if (selectedTab === "competitor_rank") {
    return [
      { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
      {
        id: "attribute",
        name: `${ENTITY_LABELS.rank} Prompt (Competitor Set)`,
        sorting: false,
        Cell: QuestionCell,
      },

      { id: "action", name: "Action", sorting: false, Cell: ActionCell },
    ];
  } else if (selectedTab === "propensity-visibility") {
    return [
      { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
      {
        id: "attribute",
        name: `Purchase Intent ${ENTITY_LABELS.rank} Prompt`,
        sorting: false,
        Cell: QuestionCell,
      },

      { id: "action", name: "Action", sorting: false, Cell: ActionCell },
    ];
  } else if (selectedTab === "categoryDimension") {
    return [
      { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
      {
        id: "attribute",
        name: "Category Dimensions",
        sorting: false,
        Cell: QuestionCell,
      },

      { id: "action", name: "Action", sorting: false, Cell: ActionCell },
    ];
  } else if (selectedTab === "propensity-to-buy") {
    return [
      { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
      {
        id: "attribute",
        name: "Purchase Intent Questions",
        sorting: false,
        Cell: QuestionCellWithProductReplace,
      },
      { id: "action", name: "Action", sorting: false, Cell: ActionCell },
    ];
  } else {
    const TitleName = getTitleName();
    return [
      { id: "index", name: "Id", sorting: true, Cell: SequenceCell },
      { id: "factor", name: "Factor", sorting: false, Cell: FactorCell },
      {
        id: "attribute",
        name: `${TitleName[selectedTab] || "Sentiment Question"}s`,
        sorting: false,
        Cell: QuestionCellWithProductReplace,
      },
      { id: "action", name: "Action", sorting: false, Cell: ActionCell },
    ];
  }
}

export default function Sentiment({
  selectedSideTab,
  editIconClick,
  selectedTab,
}) {
  const [orderBy, setOrderBy] = React.useState("brand");
  const [order, setOrder] = React.useState("asc");
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const TitleName = getTitleName();
  const brands = useSelector((state) => state.brands);

  const setData = useSelector((store) => store.userSet);

  const dispatch = useDispatch();

  let key = `${TitleName[selectedTab]}`;

  let data = setData?.data?.find((ele) => ele.id == selectedSideTab) ?? {};

  const handleDeleteSentiment = (id) => {
    dispatch(deleteAttribute({ id, type: selectedTab }))
      .then(() => {
        /*it does the work of removing the that particualr */
        dispatch({
          type: "HANDLE_ATTRIBUTE_DELETE",
          payload: { id, type: selectedTab, selectedSideTab, key },
        });
        toast.success(`${key} delete successfully`);
      })
      .catch((err) => {
        console.log(`Fail to Delete ${key}, err.message`);
      });
    setShowModal(false);
  };

  const handleShowModal = (id) => {
    setShowModal(true);
    setSelectedId(id);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const rawAttributeList = data[selectedTab] ?? [];
  const attributeList =
    selectedTab === "sentiment" ? groupByFactor(rawAttributeList) : rawAttributeList;
  const isDefault = selectedSideTab === "default";

  const hasAnyFactor = rawAttributeList.some((item) => item?.factor);
  const TABLE_HEADERS = renderTableHeader({ selectedTab }).filter(
    (header) => header.id !== "factor" || hasAnyFactor
  );

  const renderRow = (item, index) => {
    return (
      <StyledTableRow key={item.id}>
        {TABLE_HEADERS.map((cell) => {
          let Cell = cell.Cell;
          return (
            <Cell
              Key={cell.id}
              key={cell.id}
              item={item}
              isDefault={isDefault}
              index={index}
              handleShowModal={handleShowModal}
              editIconClick={editIconClick}
            />
          );
        })}
      </StyledTableRow>
    );
  };

  // <StyledTableCell align="left" style={{ width: 300 }}>
  //   {item.persona.slice(0, 2).map((p) => (
  //     <MUIChip
  //       label={p.persona.name}
  //       bgColor={
  //         CHIP_COLORS[Math.floor(Math.random() * CHIP_COLORS.length)]
  //       }
  //     />
  //   ))}
  //   {item.persona.length - 2 > 0 ? (
  //     <Tooltip
  //       title={renderToolTipContent(
  //         item.persona.slice(2, item.persona.length)
  //       )}
  //     >
  //       <span></span>
  //       <MUIChip label={${item.persona.length - 2}+} bgColor="#858585" />
  //     </Tooltip>
  //   ) : null}
  // </StyledTableCell>
  // <StyledTableCell align="left" style={{ width: 100 }}>
  //   <div className={classes.status}>
  //     <CheckCircleIcon style={{ color: "#028101" }} />
  //     <span>{item.is_active == 1 ? "Active" : "Inactive"}</span>
  //   </div>
  // </StyledTableCell>
  // <StyledTableCell align="left">
  //   <div>
  //     <MUIIconButton
  //       style={{ color: "#028101" }}
  //       className={classes.action_btn}
  //     >
  //       <PlayArrowIcon />
  //     </MUIIconButton>

  //     <MUIIconButton
  //       tooltip="Delete"
  //       style={{ color: "#da1a04" }}
  //       onClick={() => handleShowModal(item?.id)}
  //       className={classes.action_btn}
  //     >
  //       <DeleteOutlineIcon />
  //     </MUIIconButton>

  //   </div>
  // </StyledTableCell>

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  if (brands?.loading) return <Spinner />;

  return (
    <>
      <ConfirmTempplateModal
        show={showModal}
        handleConfirmDeletion={handleDeleteSentiment}
        selectedId={selectedId}
        handleClose={handleClose}
        message={`Are you sure you want to delete this ${key} ?`}
        attributeLength={attributeList?.length ?? 0}
        selectedTab={selectedTab}
      />
      {attributeList && attributeList.length !== 0 ? (
        <div
          style={{
            border: `1px solid #c9cccc`,
            borderRadius: "4px",
            borderTop: "0px",
            flex: 1,
            overflow: "auto",
          }}
          className={classes.hideTableBorder}
        >
          <Table
            headers={TABLE_HEADERS}
            data={attributeList}
            render={renderRow}
            orderBy={orderBy}
            order={order}
            onSort={handleRequestSort}
            isDefault={isDefault}
          />
        </div>
      ) : (
        <EmptyView message="Nothing here." />
      )}
    </>
  );
}
